@if (process && process['timesheet']) {
  <div class="container-fluid">
    <!--    <ul class="nav nav-tabs" id="myTab" role="tablist">-->
    <!--        <li class="nav-item" (click)="getTab('active')">-->
    <!--            <a class="nav-link active" data-bs-toggle="tab" role="tab" id="active-tab"-->
  <!--                href="#active" attr.aria-controls="active">Active</a>-->
<!--        </li>-->
<!--        <li class="nav-item" (click)="getTab('submitted')">-->
<!--            <a class="nav-link" data-bs-toggle="tab" role="tab" id="submitted-tab"-->
<!--                href="#submitted" attr.aria-controls="submitted">Submitted</a>-->
<!--        </li>-->
<!--        <li class="nav-item" (click)="getTab('approved')">-->
<!--            <a class="nav-link" data-bs-toggle="tab" role="tab" id="approved-tab"-->
<!--                href="#approved" attr.aria-controls="approved">Approved</a>-->
<!--        </li>-->
<!--    </ul>-->
<nav ngbNav class="nav-tabs" #nav="ngbNav" [destroyOnHide]="false" [(activeId)]="activeId">
  <ng-container [ngbNavItem]="0">
    <a ngbNavLink (click)="getTab('active')">
      Active
    </a>
    <ng-template ngbNavContent>
      <div class="tab-pane fade show active" id="active" role="tabpanel" aria-labelledby="active-tab">
        <div class="row">
          <div class="col">
            <app-timesheet-table [table]="this.process.timesheet" [processId]="this.process.id" (rowEdited)="fetch()">
            </app-timesheet-table>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <button class="btn btn-primary" style="float: right;" [disabled]="this.process.timesheet.rows.length<2"
            (click)="submitSheets()">Submit</button>
          </div>
        </div>
      </div>
    </ng-template>
  </ng-container>
  <ng-container [ngbNavItem]="1">
    <a ngbNavLink (click)="getTab('submitted')">
      Submitted
    </a>
    <ng-template ngbNavContent>
      <div class="tab-pane fade show" id="submitted" role="tabpanel" aria-labelledby="submitted-tab">
        <div class="tab-pane fade show active" id="active" role="tabpanel" aria-labelledby="active-tab">
          <div class="row">
            <div class="col">
              <app-action-timesheet [user]="user" [timesheet]="this.process.timesheet" [processId]="this.process.id" [type]="'SUBMITTED'" (timesheetApproved)="fetch()">
              </app-action-timesheet>
            </div>
          </div>
        </div>
      </div>
    </ng-template>
  </ng-container>
  <ng-container [ngbNavItem]="2">
    <a ngbNavLink (click)="getTab('approved')">
      Approved
    </a>
    <ng-template ngbNavContent>
      <div class="tab-pane fade show" id="approved" role="tabpanel" aria-labelledby="approved-tab">
        <div class="tab-pane fade show active" id="active" role="tabpanel" aria-labelledby="active-tab">
          <div class="row">
            <div class="col">
              <app-action-timesheet [user]="user" [timesheet]="this.process.timesheet" [type]="'APPROVED'"
              [processId]="this.process.id"></app-action-timesheet>
            </div>
          </div>
        </div>
      </div>
    </ng-template>
  </ng-container>
</nav>
<div [ngbNavOutlet]="nav" class="mt-0"></div>
<!--    <div class="tab-content" id="myTabContent">-->
<!--        <div class="tab-pane fade show active" id="active" role="tabpanel" aria-labelledby="active-tab">-->
<!--            <div class="row">-->
<!--                <div class="col">-->
<!--                    <app-timesheet-table [table]="this.process.timesheet" [processId]="this.process.id" (rowEdited)="fetch()">-->
<!--                    </app-timesheet-table>-->
<!--                </div>-->
<!--            </div>-->
<!--            <div class="row">-->
<!--                <div class="col">-->
<!--                    <button class="btn btn-primary" style="float: right;" [disabled]="this.process.timesheet.rows.length<2"-->
<!--                    (click)="submitSheets()">Submit</button> -->
<!--                </div>-->
<!--            </div>-->
<!--        </div>-->
<!--        <div class="tab-pane fade show" id="submitted" role="tabpanel" aria-labelledby="submitted-tab">-->
<!--            <div class="tab-pane fade show active" id="active" role="tabpanel" aria-labelledby="active-tab">-->
<!--                <div class="row">-->
<!--                    <div class="col">-->
<!--                        <app-action-timesheet [user]="user" [timesheet]="this.process.timesheet" [processId]="this.process.id" [type]="'SUBMITTED'" (timesheetApproved)="fetch()">-->
<!--                        </app-action-timesheet>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->
<!--        </div>-->
<!--        <div class="tab-pane fade show" id="approved" role="tabpanel" aria-labelledby="approved-tab">-->
<!--            <div class="tab-pane fade show active" id="active" role="tabpanel" aria-labelledby="active-tab">-->
<!--                <div class="row">-->
<!--                    <div class="col">-->
<!--                        <app-action-timesheet [user]="user" [timesheet]="this.process.timesheet" [type]="'APPROVED'"-->
<!--                        [processId]="this.process.id"></app-action-timesheet>-->
<!--           -->
<!--                    </div>-->
<!--                </div>-->
<!--              -->
<!--            </div>-->
<!--        </div>-->
<!--    </div>-->
<div class="row">
  <div class="col" style="margin-top: 20px;">
    <hr />
    @if (process) {
      <app-file-upload-element [documentSection]="true" [fileupload]="process.timesheet.upload && !isEmpty(process.timesheet.upload)?process.timesheet.upload:uploadElement" [processId]="process.id"
      (onUploadDone)="onFileUpload(uploadElement.key, $event)"  (documentDeleted)="deleteFromProcess()"></app-file-upload-element>
    }
  </div>
</div>
<div class="row">
  <div class="col" style="margin-top: 20px;">
    <hr />
    <app-action-element [item]="this.process.timesheet.caseActivity" [taskKey]="'timesheet'"
      [singleSave] = 'true'
      (onSingleSaveClick)="saveCaseActivity()"
      [processId]="process.id" (onTaskContentChange)="contentChanged($event)">
    </app-action-element>
  </div>
</div>
</div>
}
